
import { check, commonApi } from '@/common/index';
import { mapState } from 'vuex';
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import { ValidateRequire, validataDrawPwd } from '@/common/utils/validate.js'
export default {
name: 'alterDrawings',
components: {
XHeader,
Group,
XInput,
XButton,
Cell,
Countdown,
PopupPicker,
},
data() {
return {
showCountdown: true,
time: 60,
disabled: false,
start: false,
isReady: true,

phoneNumber: '',
verifCode: '',
password: '',
newPassword: '',
rePassword: '',

}
},
computed: {
...mapState({
UUID: state => state.UUID,
serverInfo: state => state.userInfo.serverInfo
})
},
created() {

if (this.$store.state.linkList.withdrawMethod === '0') this.phoneNumber = this.$store.state.userInfo.userInfo.mobilePhone 
},
methods: {
handleSubmit() {
if (!this.checkForm()) return
let params = {
UUID: this.UUID,
phoneYzm: this.verifCode,
oldWithdrawPSW: this.password,
newWithdrawPSW: this.newPassword,
}
if (this.isReady) {
this.isReady = false;
if (this.$store.state.userInfo.userInfo.withdrawPasswordValid) { // 已设置过密码 修改
commonApi.CONFIRM.updateWithdrawPW(params).then(data => {
this._setSuccess()
}).catch(err => {
this.isReady = true;
this.haveComTotas(err,'cancel')
});
} else {
this.setWithdrawPW()
}
}
},
setWithdrawPW() { // 设置初始密码
const params = { withdrawPSW: this.newPassword, UUID: this.UUID, phoneYzm: this.verifCode }
this.$api.post(this.$urls.PAY.setWithdrawPW, params, (resp)=>{
if(resp.data.code===200) this._setSuccess()
if(resp.data.code!==200) this.haveComTotas(resp.data.msg,'cancel')
this.isReady = true
},err=>{
this.haveComTotas(err,'cancel')
})
},

_setSuccess() {
this.isReady = true;
this.haveComTotas(this.$t('mine').withdrawPwd.successTips,'success')
let timer = setTimeout(() => {
this.$router.replace({ path: '/My/AccountManat' })
this.$store.dispatch('getFirstInfo') 
clearTimeout(timer)
},1000)
},

sendCode() {
this.start = true;
this.disabled = true;
let params = {
UUID: this.UUID,
phone: this.phoneNumber,
};
commonApi.CONFIRM.sendPhone(params)
.then(data => {
this.newPhone = this.phoneNumber
}).catch(err => {
this.finish();
this.haveComTotas(err,'cancel')
})
},

finish() {
this.disabled = false;
this.start = false;
this.time = 60
},

checkForm() {
if (this.serverInfo.withdrawMethod === '0' && !ValidateRequire(this.verifCode)) { // 需要验证验证码
this.haveComTotas(this.$t('mine').mobileAuth.verifCodePlace,'cancel')
return
}

if(this.$store.state.userInfo.userInfo.withdrawPasswordValid && !ValidateRequire(this.password)){
this.haveComTotas(this.$t('mine').withdrawPwd.pwdPlace,'cancel')
return
}
if (this.$store.state.userInfo.userInfo.withdrawPasswordValid && !validataDrawPwd(this.password)) {
this.haveComTotas(this.$t('Forms').drawPwdError,'cancel')
return
}

if(!ValidateRequire(this.newPassword)){
this.haveComTotas(this.$t('mine').withdrawPwd.newPwdPlace,'cancel')
return
}
if (!validataDrawPwd(this.newPassword)) {
this.haveComTotas(this.$t('Forms').drawPwdError,'cancel')
return
}

if(this.$store.state.userInfo.userInfo.withdrawPasswordValid && this.password === this.newPassword){
this.haveComTotas(this.$t('Forms').pwdDiff,'cancel')
return
}

if(!ValidateRequire(this.rePassword)){
this.haveComTotas(this.$t('Forms').repeatPwdPlace,'cancel')
return
}

if(this.rePassword !== this.newPassword){
this.haveComTotas(this.$t('Forms').newDiff,'cancel')
return
}

return true
},

haveComTotas(data,istype){
this.$vux.toast.show({ text: data,type: istype});
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/AccountManat/WithdrawPasword.vue